<template>
   <v-container
      class="fill-height pa-4"
      fluid
    >
      <v-row
            shrink
            no-gutters
            align="center"
            justify="center"
            dense
            class="ma-4"
          >
          <v-col cols="12">
            
            <v-row class="ma-2">
             
            </v-row>
            <v-row align="center" justify="center">
              <div style="width:100%; max-width:600px">
                <div class="display-2 white--text font-weight-thin">
                New Section
                </div>
                 <v-divider class="ma-2"></v-divider>
                <v-stepper v-model="step" >
                  <v-stepper-header>
                    <v-stepper-step editable :complete="stepOneComplete" step="1">Describe</v-stepper-step>
                    <v-stepper-step :editable="stepOneComplete" :complete="stepTwoComplete" step="2">Visualize </v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-text-field
                        v-model="name"
                        label="Section Name"
                        filled
                        :rules="[rules.required]"
                      ></v-text-field>
                      <v-textarea
                        filled
                        label="Short Description"
                        auto-grow
                        v-model="desc"
                      ></v-textarea>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-row>
                        <v-col cols="4" class="pa-1">
                          <v-card
                          height="200px"
                          >
                            <v-img contain :src='(files.length) ? files[0].thumb : ""'
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="8" class="pa-1" >
                          <v-card
                          class="upload"
                          color="transparent"
                          height="200px"
                          flat
                          >
                            <v-container 
                            v-if="!files.length"
                            class="fill-height pa-4"
                            fluid> 
                              <v-row  justify="center" align="center">
                                <v-btn>
                                  <label for="file" class="btn btn-lg btn-primary" style="">
                                    Drop or Select Files
                                  </label>
                                </v-btn>
                              </v-row>
                            </v-container>
                            <v-simple-table v-else>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">File Name</th>
                                    <th class="text-left"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(file,index) in files" :key="file.id">
                                    <td>{{ file.name }}</td>
                                    <td>
                                      <v-btn color="red" icon
                                      @click="files.splice(index,1)"
                                      ><v-icon>mdi-file-remove</v-icon></v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <v-btn v-if="files.length">
                              <label for="file" class="btn btn-lg btn-primary" style="">
                                Select different file
                              </label>
                            </v-btn>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                  <file-upload
                        :post-action= postEndPoint
                        :multiple="false"
                        :drop="true"
                        :drop-directory="true"
                        :maximum="1"
                        accept="image/*"
                        @input-filter="inputFilter"
                        v-model="files"
                        ref="upload"
                        :headers="GetAuthHeaderObj()">
                      </file-upload>
                </v-stepper>
                <div v-if="fileUploadComplete">
                  Upload complete
                </div>
                 <v-row shrink dense justify="end" class="pa-0 ma-0 mt-2">
                    <v-btn
                        color="primary"
                        @click="NextStep"
                        :disabled="!canContinue"
                      >
                        {{continueName}}
                      </v-btn>

                      <v-btn class="ml-2" @click="$router.go(-1)" >Cancel</v-btn>
                  </v-row>
              </div>
            </v-row>
          </v-col>
      </v-row>
  </v-container>
</template>


<script>

import FileUpload from 'vue-upload-component'
import CONFIG from '../../../appconfig.json'

import {mapActions} from 'vuex'

import { mapGetters } from 'vuex'

export default {
  components: {FileUpload},
  props: {

  },
  computed:{

    assetxpEndPoint() {
      return CONFIG.platformEndpoints.assetxpapi + "/";
    },
    stepOneComplete() {
      if(this.$data.name != "")
        return true;

      return false;
    },
    stepTwoComplete() {
      if(this.$data.imgUrl != "")
        return true;

      return false;
    },
    continueName() {
      if(this.step == 1)
      {
        return "Continue";
      }
      else if (this.step == 2)
      {
        return "Create";
      }
      else
      {
        return "Continue";
      }
    },
    canContinue() {
      if(this.step == 1)
      {
        return this.stepOneComplete;
      }
      else if (this.step == 2)
      {
        return true;
      }
      else
        return false;
    },
    fileUploadComplete() {
      if(this.files.length > 0)
      {
        if(this.files[0].success)
        {
          this.$router.push("/" + this.name);
          return true;
        }
      }

      return false;
    },
    postEndPoint() {

      return this.assetxpEndPoint + "/section/uploadimg/" + this.createdSection.id;
    }
  },
  data: () => ({
    files: [],
    step : 1,
    name : "",
    desc : "",
    file : {},
    imgUrl : "",
    rules: {
      required: value => !!value || 'Required.'
    },
    check : true,
    createdSection : {id : "0"}
  }),
   mounted :  function () {

     if(!this.CanUserEditAssets())
     {
       this.$router.push("/");
     }

  },
  methods:{

    ...mapGetters("authentication", [
        "CanUserEditAssets",
        "GetAuthHeaderObj"
    ]),

    ...mapActions("assetxpstate", [
        "CreateSection"
    ]),

    NextStep()
    {
      if(this.$data.step == 1)
      {
        this.$data.step++;
      }
      else if (this.$data.step ==2)
      {
        this.CreateSection({name : this.name, description: this.desc}).then( (newSection) =>{

          this.createdSection = newSection;
          if (this.files[0]) this.files[0].postAction = this.postEndPoint;

          this.$refs.upload.active = true;

          this.$router.push("/");
        });
      }
    },
    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
    }
  }
}
</script> 

<style>

</style>